import React from 'react';

import { Container, Row, Col } from 'aplazame-design-system';

import HtmlComponent from '../HtmlComponent';


export default function ContentSection({
    text,
    isLast,
    order,
    previousSectionType,
    center = false,
    htmlType
}) {
    const previousIsHero = [ 'DatoCmsHeroSection', 'DatoCmsHeroFormSection' ].indexOf(previousSectionType) !== -1;

    return (
        <section>
            <Container
                pt={{
                    xs: order === 1 ? 4 : (previousIsHero ? 5 : 0),
                    lg: order === 1 ? 14 : 0
                }}
                pb={{
                    xs: isLast ? 8 : 0,
                    lg: isLast ? 20 : 0
                }}
            >
                <Row>
                    <Col
                        col={center ? { xs: 12 } : { xl: 10, xxl: 8 }}
                        offset={center ? {} : { xl: 1, xxl: 2 }}
                    >
                        <HtmlComponent
                            type={htmlType}
                            html={text}
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}